var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinksicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cards_-_Link",
    "data-name": "Cards - Link",
    transform: "translate(-5023 1225)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3041",
    "data-name": "Rectangle 3041",
    width: 24,
    height: 24,
    transform: "translate(5023 -1225)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "link-svgrepo-com",
    d: "M11.959,15.9a1.17,1.17,0,0,0,0-1.655,3.288,3.288,0,0,1,0-4.65L15.9,5.658a3.288,3.288,0,1,1,4.65,4.65l-1.218,1.217a1.17,1.17,0,0,0,1.655,1.655l1.218-1.217A5.629,5.629,0,1,0,14.245,4L10.3,7.943a5.629,5.629,0,0,0,0,7.96,1.171,1.171,0,0,0,1.655,0Zm2.285-5.6a1.17,1.17,0,0,0,0,1.655,3.288,3.288,0,0,1,0,4.65l-3.9,3.9a3.288,3.288,0,1,1-4.649-4.65l1.143-1.142a1.17,1.17,0,1,0-1.655-1.655L4.04,14.209A5.629,5.629,0,0,0,12,22.169l3.9-3.9a5.629,5.629,0,0,0,0-7.96,1.17,1.17,0,0,0-1.655,0Z",
    transform: "translate(5021.878 -1226.086)",
    fill: "#707070",
    stroke: "#fff",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinksicon);
export default __webpack_public_path__ + "static/media/linksicon.9dff3b0e9620a750170a66e87bb7ba87.svg";
export { ForwardRef as ReactComponent };